export default function SafetySection() {
  return (
    <section id="safety" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
            Your Safety Matters
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            We focus on providing educational information to help you make informed decisions when using shopping agent services. Our <strong className="text-foreground-900">Basetao spreadsheet</strong> resources are designed to guide you through safe shopping practices.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left">
            {[
              { label: 'Website URLs', desc: 'Always verify you are on the official Basetao website before entering any personal information.' },
              { label: 'Payment Methods', desc: 'Use secure payment options and review transaction details carefully before completing any purchase.' },
              { label: 'Seller Reputation', desc: 'Check seller ratings, history, and community feedback before placing orders through any agent.' },
              { label: 'Product Quality', desc: 'Review QC photos carefully and understand return policies before confirming shipment.' },
              { label: 'Shipping Information', desc: 'Compare shipping lines, delivery times, and insurance options to choose the safest method for your location.' },
              { label: 'Personal Data', desc: 'Never share sensitive personal information with unknown sources or unverified third parties.' },
            ].map((item) => (
              <div key={item.label} className="flex gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
                <div className="w-5 h-5 flex-shrink-0 mt-0.5 flex items-center justify-center text-primary-500">
                  <i className="ri-checkbox-circle-fill text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">{item.label}</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}